import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { QRCodeComponent } from 'angularx-qrcode';
import { PreorderService } from 'src/app/services/preorder.service';
@Component({
    selector: 'app-article-qr-modal',
  standalone: true,
  imports: [QRCodeComponent],
    templateUrl: './article-qr-modal.component.html',
    styleUrl: './article-qr-modal.component.scss'
})
export class ArticleQrModalComponent {
  articleCode: string;
  url: string;
  constructor(public modal: NgbActiveModal, private preorderService: PreorderService) {
  }

  ngOnInit() {
    this.url = this.preorderService.preOrderUrl(this.articleCode);
  }
}
